import React, { useEffect, useState } from 'react'
import dynamic from 'next/dynamic';
import { MdChevronRight } from '@react-icons/all-files/md/MdChevronRight';
import { MdChevronLeft } from '@react-icons/all-files/md/MdChevronLeft';
import ScrollCarousel from '../public/js/ScrollCarouselAutoPlay';

const CustomImage = dynamic(() => import('./CustomImage'));
let data = [
    {
        name: 'Shaurya Mehta',
        userImg: 'shaurya.png',
        university: 'Stanford University',
        universityImg: '',
        course: 'Economics',
        comment: 'My two year association with Collegify has been wonderful to say the least. Right from taking SAT classes to preparing for my application, I have received unconditional support at every step. Adarsh Sir was extremely supportive. In fact, every member of the team was involved in my application - thus adding new dimensions to my profile & application. I am so happy at my acceptance to Stanford! A DREAM COME TRUE FOR ME! I cannot thank Collegify enough for everything!'
    },
    {
        name: 'Pratyush Sudhakar',
        userImg: 'pratush.png',
        university: 'Cornell University',
        universityImg: '',
        course: 'Computer Science Engineering',
        comment: "Adarsh Sir's work is unparalleled in the industry. Not only me, but my sister Sukriti also got the Tata Scholarship at Cornell. His predictions are absolutely spot-on. My family is very grateful to Adarsh Sir and his incredible team at Collegify."
    },
    {
        name: 'Priyanshi Sharma',
        userImg: 'priyanshi.png',
        university: 'McGill University, Canada',
        universityImg: '',
        course: 'Psychology',
        comment: 'A special thanks to Adarsh Sir and the team of Collegify for guiding me in the right direction – their advice, unique projects, time management techniques and support ensured I got admitted into all the colleges I applied to both in Canada and the UK. I received unexpected scholarships and one offer to join directly from 2nd year!  Along with college admissions, I have gained skills that will prove to be invaluable in college as well.'
    },
    {
        name: 'Aveesha Gandhi',
        userImg: 'Aveesha.jpeg',
        university: 'University Of Chicago',
        universityImg: '',
        course: 'Economics',
        comment: 'For anyone looking for even the smallest amount of guidance in something as challenging and nuanced as applying to your dream university, Collegify has the most insane mentors who provide you with this incredibly personalised college application journey, eliminating all related stress and doubts, to help you reach where you have always envisioned yourself.'
    },
    {
        name: 'Yugam Bajaj',
        userImg: 'Yugam.jpg',
        university: 'London School Of Economics',
        universityImg: '',
        course: 'Masters in Management',
        comment: 'Adarsh Sir helped me stay confident and focused despite challenging circumstances given the pandemic. His constant encouragement and unwavering support played a pivotal role in my admission. Not to mention, his team of mentors did an incredible job in guiding me with my admissions essays.'
    },
    {
        name: 'Mihikaa Goenka',
        userImg: 'mihika-goenka.png',
        university: 'Cornell University',
        universityImg: '',
        course: '',
        comment: 'Collegify was able to understand my needs and helped me prioritize a list of colleges that would be a good fit for me. I finally picked Cornell for computer science.'
    }
]


export default function AKTestimonialNew({list}) {
    const [testimonialList, changeTestimonialList] = useState(list? list: data);

    useEffect(() => {
        const carousels = document ? document.querySelectorAll('#testimodal-autoplay') : undefined;
        if(!carousels) return;
        carousels.forEach(carousel => new ScrollCarousel(carousel).init());
        return () => {
            carousels.forEach(carousel => new ScrollCarousel(carousel).destroy());
        }
    }, [])
    
    function firePopup(e){
        if(e.target.parentElement.getAttribute('disabled') !== null){
            const fireModal = new bootstrap.Modal(document.getElementById('freeConsultationModal'), {});
            fireModal.show();
        }
        
    }
    return (
        <section className='testimonial-section'>
            <h2 className='text-center fw-bold mb-1 text-primary'>Testimonials</h2>
            <div className='colored-line line-center'></div>
            <div className="carousel" id="testimodal-autoplay"
                data-pagination
            >
                <button
                    className="carousel__ctrl _prev"
                    data-elem-prev-button
                    tabIndex="-1"
                    aria-hidden="true"
                >
                    <MdChevronLeft fontSize="28px" className='font-weight-bold' /> 
                </button>
                <div className="carousel__track" data-elem-carousel-track>
                    {
                        testimonialList.map((data, i) => (
                            <div className="box _half" tabIndex="0" key={`testimonials-${i}`}>
                                <div className="testimonial-box">
                                    <div className="top-admission--card">
                                        <div className="avatar big">
                                            <CustomImage srcSetPaths={[{path: `/students/${data.userImg}?tr=w-140,f-avif`, type: 'image/avif'},{path: `/students/${data.userImg}?tr=w-140,f-auto`, type: 'image/webp'}]}
                                                mainSrc={`/students/${data.userImg}?tr=w-140,f-png`} alt={data.name} width="140" height="140" imgCDN loading="eager" />
                                        </div>
                                        <div className="card-body text-center">
                                            <div className='testimonial-text'>
                                                <p className="txt-14--caption mb-3">{data.comment}</p>
                                            </div>
                                        </div>
                                        <div className="univeristy-mention">
                                            <h5 className='mb-1'>{data.name}</h5>
                                            <h6>{data.course}{data.course && <br/>}{data.university}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>

                
                <button
                    className="carousel__ctrl _next"
                    data-elem-next-button
                    tabIndex="-1"
                    aria-hidden="true"
                    onClick={firePopup}
                    style={{backgroundColor: '#fff !important'}}
                >
                    <MdChevronRight fontSize="28px" className='font-weight-bold' />
                </button>     
            </div>
        </section>
    )
}
